export var CONSTANTS = {
    THEME_MODE: {
        DARK: 'dark',
        LIGHT: 'light',
    },
};
export var THEME_VALUE;
(function (THEME_VALUE) {
    THEME_VALUE["LIGHT"] = "light";
    THEME_VALUE["DARK"] = "dark";
    THEME_VALUE["DEFAULT"] = "default";
})(THEME_VALUE || (THEME_VALUE = {}));
export var DOMAIN_SETTING_LOGIN;
(function (DOMAIN_SETTING_LOGIN) {
    DOMAIN_SETTING_LOGIN[DOMAIN_SETTING_LOGIN["AWS"] = 1] = "AWS";
    DOMAIN_SETTING_LOGIN[DOMAIN_SETTING_LOGIN["AZURE"] = 2] = "AZURE";
    DOMAIN_SETTING_LOGIN[DOMAIN_SETTING_LOGIN["ONLY_AZURE"] = 3] = "ONLY_AZURE";
})(DOMAIN_SETTING_LOGIN || (DOMAIN_SETTING_LOGIN = {}));
export var FONT_NAME_OPTIONS = [
    { id: 'Lato', label: 'Lato' },
    { id: 'Arial', label: 'Arial' },
    { id: 'AkkuratStd', label: 'Akkurat Std' },
    { id: 'SourceSansPro', label: 'Source Sans Pro' },
];
export var LANGUAGE_OPTIONS = [
    { id: 'enUS', label: 'English (US)' },
    { id: 'enUK', label: 'English (UK)' },
];
export var DEFAULT_MSG_CODE = {
    ERROR_MSG_CODE: '99999',
};
export var DASHBOARD_DATA_URL = 'https://viz.its.nec.com.au/views/Superstore/{0}?:origin=card_share_link&:embed=n';
export var USER_MANUAL_PDF_URI = 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';
export var WIDGETS_NAME;
(function (WIDGETS_NAME) {
    WIDGETS_NAME["OVERVIEW"] = "Overview";
    WIDGETS_NAME["PRODUCT"] = "Product";
    WIDGETS_NAME["CUSTOMERS"] = "Customers";
    WIDGETS_NAME["SHIPPING"] = "Shipping";
    WIDGETS_NAME["PERFORMANCE"] = "Performance";
    WIDGETS_NAME["COMMISSION_MODEL"] = "CommissionModel";
    WIDGETS_NAME["ORDER_DETAILS"] = "OrderDetails";
    WIDGETS_NAME["FORECAST"] = "Forecast";
    WIDGETS_NAME["WHAT_IF_FORE_CAST"] = "WhatIfForecast";
})(WIDGETS_NAME || (WIDGETS_NAME = {}));
export var WIDGETS_ID;
(function (WIDGETS_ID) {
    WIDGETS_ID["OVERVIEW"] = "overview";
    WIDGETS_ID["PRODUCT"] = "product";
    WIDGETS_ID["CUSTOMERS"] = "customers";
    WIDGETS_ID["SHIPPING"] = "shipping";
    WIDGETS_ID["PERFORMANCE"] = "performance";
    WIDGETS_ID["COMMISSION_MODEL"] = "commissionModel";
    WIDGETS_ID["ORDER_DETAILS"] = "orderDetails";
    WIDGETS_ID["FORECAST"] = "forecast";
    WIDGETS_ID["WHAT_IF_FORE_CAST"] = "whatIfForecast";
})(WIDGETS_ID || (WIDGETS_ID = {}));
export var WIDGETS_LIST = [
    {
        id: WIDGETS_ID.OVERVIEW,
        name: WIDGETS_NAME.OVERVIEW,
        refreshTime: 60000,
    },
    {
        id: WIDGETS_ID.PRODUCT,
        name: WIDGETS_NAME.PRODUCT,
        refreshTime: 70000,
    },
    {
        id: WIDGETS_ID.CUSTOMERS,
        name: WIDGETS_NAME.CUSTOMERS,
        refreshTime: 80000,
    },
    {
        id: WIDGETS_ID.SHIPPING,
        name: WIDGETS_NAME.SHIPPING,
        refreshTime: 90000,
    },
    {
        id: WIDGETS_ID.PERFORMANCE,
        name: WIDGETS_NAME.PERFORMANCE,
        refreshTime: 50000,
    },
    {
        id: WIDGETS_ID.COMMISSION_MODEL,
        name: WIDGETS_NAME.COMMISSION_MODEL,
        refreshTime: 40000,
    },
    {
        id: WIDGETS_ID.ORDER_DETAILS,
        name: WIDGETS_NAME.ORDER_DETAILS,
        refreshTime: 45000,
    },
    {
        id: WIDGETS_ID.FORECAST,
        name: WIDGETS_NAME.FORECAST,
        refreshTime: 55000,
    },
    {
        id: WIDGETS_ID.WHAT_IF_FORE_CAST,
        name: WIDGETS_NAME.WHAT_IF_FORE_CAST,
        refreshTime: 100000,
    },
];
export var ROLE;
(function (ROLE) {
    ROLE["SUPER_ADMIN"] = "SUPER ADMIN";
    ROLE["ORGANIZATION_ADMIN"] = "ADMIN";
    ROLE["USER"] = "USER";
})(ROLE || (ROLE = {}));
export var ROLE_FUNCTIONS = {
    VIEW_USERS: 'VIEW_USERS',
    VIEW_USER_DETAIL: 'VIEW_USER_DETAIL',
    UPDATE_USER_CONFIGURATION: 'UPDATE_USER_CONFIGURATION',
    VIEW_PRODUCTS_OF_USER_ORGANIZATION: 'VIEW_PRODUCTS_OF_USER_ORGANIZATION',
    VIEW_ROLES_FOR_USER_ASSIGNMENT: 'VIEW_ROLES_FOR_USER_ASSIGNMENT',
    USER_ROLE_MAPPING: 'USER_ROLE_MAPPING',
    VIEW_AUDITS: 'VIEW_AUDITS',
    VIEW_DISPLAYS: 'VIEW_DISPLAYS',
    VIEW_DISPLAY_DETAIL: 'VIEW_DISPLAY_DETAIL',
    UPDATE_DISPLAY: 'UPDATE_DISPLAY',
    DELETE_DISPLAYS: 'DELETE_DISPLAYS',
    DISPLAY_CAMPAIGN_MAPPING: 'DISPLAY_CAMPAIGN_MAPPING',
    VIEW_CAMPAIGNS_FOR_DISPLAY_ASSIGNMENT: 'VIEW_CAMPAIGNS_FOR_DISPLAY_ASSIGNMENT',
    CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
    VIEW_CAMPAIGNS: 'VIEW_CAMPAIGNS',
    VIEW_CAMPAIGN_DETAIL: 'VIEW_CAMPAIGN_DETAIL',
    UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
    DELETE_CAMPAIGNS: 'DELETE_CAMPAIGNS',
    CAMPAIGN_DISPLAY_MAPPING: 'CAMPAIGN_DISPLAY_MAPPING',
    VIEW_DISPLAYS_FOR_CAMPAIGN_ASSIGNMENT: 'VIEW_DISPLAYS_FOR_CAMPAIGN_ASSIGNMENT',
    CAMPAIGN_IMAGE_MAPPING: 'CAMPAIGN_IMAGE_MAPPING',
    VIEW_ASSIGNED_IMAGES_FOR_CAMPAIGN_ASSIGNMENT: 'VIEW_ASSIGNED_IMAGES_FOR_CAMPAIGN_ASSIGNMENT',
    CREATE_FOLDER: 'CREATE_FOLDER',
    VIEW_FOLDERS_TO_MOVE: 'VIEW_FOLDERS_TO_MOVE',
    UPLOAD_IMAGES: 'UPLOAD_IMAGES',
    VIEW_IMAGE_LIBRARY: 'VIEW_IMAGE_LIBRARY',
    VIEW_IMAGE_DETAIL: 'VIEW_IMAGE_DETAIL',
    VIEW_SUB_FOLDER: 'VIEW_SUB_FOLDER',
    UPDATE_IMAGE: 'UPDATE_IMAGE',
    DELETE_IMAGES: 'DELETE_IMAGES',
    MOVE_IMAGES: 'MOVE_IMAGES',
    VIEW_CAMPAIGNS_FOR_IMAGE_ASSIGNMENT: 'VIEW_CAMPAIGNS_FOR_IMAGE_ASSIGNMENT',
    IMAGE_CAMPAIGN_MAPPING: 'IMAGE_CAMPAIGN_MAPPING',
    VIEW_BROADCAST_TEXT_MESSAGE: 'VIEW_BROADCAST_TEXT_MESSAGE',
    UPDATE_BROADCAST_TEXT_MESSAGE: 'UPDATE_BROADCAST_TEXT_MESSAGE',
    VIEW_ROUTES: 'VIEW_ROUTES',
    VIEW_ROUTE_DETAIL: 'VIEW_ROUTE_DETAIL',
    VIEW_GEOFENCES: 'VIEW_GEOFENCES',
    VIEW_STOPS: 'VIEW_STOPS',
};
